import { render, staticRenderFns } from "./MarketingPlanAdd.vue?vue&type=template&id=13bc8426&scoped=true"
import script from "./MarketingPlanAdd.vue?vue&type=script&lang=js"
export * from "./MarketingPlanAdd.vue?vue&type=script&lang=js"
import style0 from "./MarketingPlanAdd.vue?vue&type=style&index=0&id=13bc8426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bc8426",
  null
  
)

export default component.exports